import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/qc` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("snf_qc_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      err.response?.status === 401 &&
      !err.config.url.includes("/auth/login") &&
      window.location.pathname.startsWith("/qc") &&
      !window.location.pathname.startsWith("/qc/login")
    ) {
      localStorage.removeItem("snf_qc_token");
      window.location.href = "/qc/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/qc/file?path=${encodeURIComponent(path)}&auth=${localStorage.getItem("snf_qc_token")}`;

export const apiError = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  const status = e.response?.status;
  if (status === 500 || status === 502 || status === 503 || status === 520)
    return "The server hit a temporary snag — please wait a few seconds and try again";
  if (typeof e.response?.data === "string" && e.response.data.length > 200)
    return `Request failed (${status || "network error"}) — please try again`;
  return e.message || "Something went wrong";
};

export default api;
